export const EXPENSE_CATEGORIES = [
  'ค่าไฟ',
  'ค่าน้ำ',
  'ค่าแม่บ้าน',
  'ค่าพนักงาน',
  'ค่าเช่าที่',
  'ค่าวัตถุดิบจิปาถะ',
];
